import { createFileRoute } from '@tanstack/react-router';

import { peopleSearchSchema } from '@/features/settings';
import { PeopleTab } from '@/features/settings/components/PeopleTab';
import { useWorkspace } from '@/features/workspaces';
// By its path, not the package (its index says why).
import { MembersOnly } from '@/features/workspaces/components/MembersOnly';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/settings/people',
)({
  // The section a notification lands on (spec 193 US6).
  validateSearch: peopleSearchSchema,
  component: PeopleRoute,
});

export function PeopleRoute() {
  const { workspaceId } = Route.useParams();
  const { section } = Route.useSearch();
  const { data: workspace } = useWorkspace(workspaceId);
  if (!workspace) return null;
  return (
    // Its people are the members' business (spec 188): a reader who reached this
    // address is told so, under the Settings band.
    <MembersOnly what="People" workspaceId={workspaceId} frame={false}>
      <PeopleTab
        workspaceId={workspaceId}
        workspaceName={workspace.name}
        canManage={workspace.access?.can_manage ?? true}
        section={section}
      />
    </MembersOnly>
  );
}
